import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "15",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m9.67 7.375 4.627-4.582.943-.943c.135-.135.135-.36 0-.54l-.988-.988c-.18-.134-.404-.134-.54 0l-5.524 5.57-5.57-5.57c-.136-.134-.36-.134-.54 0l-.988.989c-.135.18-.135.404 0 .539l5.57 5.525-5.57 5.57c-.135.135-.135.36 0 .54l.988.988c.18.134.404.134.54 0l5.57-5.57 4.582 4.626.943.944c.135.134.36.134.539 0l.988-.989c.135-.18.135-.404 0-.539z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }